import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { ActionConfiguration, TonConnectUIProvider } from "@tonconnect/ui-react";
import "./polyfills";
import { initMetaPixel } from "./utils/metaPixel";
import { persistReferralAddressFromEntry } from "./utils/referral";
import { persistAdsgramTrackingFromEntry } from "./utils/adsgram";

// Checked before initMetaPixel, which removes the Telegram launch params from the URL hash.
const isTelegramMiniApp =
    window.location.hash.includes("tgWebAppPlatform") || "TelegramWebviewProxy" in window;

// Entry params are saved first: initMetaPixel removes them from the URL so Meta never receives them.
persistReferralAddressFromEntry();
persistAdsgramTrackingFromEntry();
initMetaPixel();

const manifestUrl =
    "https://cryptolotto777.com/tonconnect-manifest.json";

// Where the wallet sends the user after confirming a request: back into the Mini App.
// twaReturnUrl is used by Telegram-based wallets, returnStrategy by app wallets like Tonkeeper;
// without it Android lands on the Telegram chat list (tg://resolve) or stays in the browser.
// On the regular website the library defaults already return to the browser tab.
const miniAppUrl = "https://t.me/cryptolottery777_bot/CryptoLottery777";
const actionsConfiguration: ActionConfiguration | undefined = isTelegramMiniApp
    ? { twaReturnUrl: miniAppUrl, returnStrategy: miniAppUrl }
    : undefined;

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <TonConnectUIProvider manifestUrl={manifestUrl} actionsConfiguration={actionsConfiguration}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </TonConnectUIProvider>
);

reportWebVitals();
